import React from 'react'
import { connect } from 'react-redux'
import InsuranceActions from '../../Redux/InsuranceRedux'

class UpdateTravelPackagePrice extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      parent_id: props.parent_id || '',
      child_id: props.detail.id || '',
      form: {
        start_day: props.detail.start_day || '',
        end_day: props.detail.end_day || '',
        price: props.detail.price || ''
      }
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.form}
    const data = {
      parent_id: this.state.parent_id,
      child_id: this.state.child_id,
      form
    }
    this.props.putTravelPackagePriceRequest(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }} >
        <div className='title-block'>
          <h3 className='title mr-auto'>Update Travel Package Price</h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Start Day</label>
            </div>
            <div className='col-9'>
              <input type='number' min='1' required placeholder='placeholder' className='form-control' value={this.state.form.start_day} onChange={(event) => this._inputChange(event, 'start_day')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>End Day</label>
            </div>
            <div className='col-9'>
              <input type='number' min='1' required placeholder='placeholder' className='form-control' value={this.state.form.end_day} onChange={(event) => this._inputChange(event, 'end_day')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Price</label>
            </div>
            <div className='col-9'>
              <input type='number' min='1' required placeholder='placeholder' className='form-control' value={this.state.form.price} onChange={(event) => this._inputChange(event, 'price')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  putTravelPackagePriceRequest: (data) => dispatch(InsuranceActions.putTravelPackagePriceRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateTravelPackagePrice)



// WEBPACK FOOTER //
// ./src/Containers/Insurance/UpdateTravelPackagePrice.js